/*
500 の画面に出す問い合わせ番号。

本番では Cloudflare が付ける cf-ray の前半をそのまま使う。同じ番号を
サーバー側の handleError がログと Sentry のタグに残すので、受講生が
読み上げた番号から Workers のログと Sentry の両方を引ける。
cf-ray が無いのは手元の開発だけ
*/
export function errorRefFromRequest(request: Request): string | null {
  const ray = request.headers.get("cf-ray");
  if (!ray) return null;
  const id = ray.split("-")[0]?.trim().toLowerCase() ?? "";
  return /^[0-9a-f]{8,32}$/.test(id) ? id : null;
}

/** ブラウザ側で起きた、あるいは遷移中に起きたエラーに付ける番号 */
export function newErrorRef(): string {
  const bytes = new Uint8Array(8);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}

let documentHydrated = false;

/** 最初の描画が終わったことを記録する。root の Layout からだけ呼ぶ */
export function markDocumentHydrated(): void {
  documentHydrated = true;
}

/*
サーバーで描いたエラー画面は、そのリクエストの番号を持っている。
ハイドレーションでも同じ番号を出さないと表示が食い違うので、
最初の描画が終わるまでは root loader の番号を使う。
root loader の値が無いまま最初の描画をするときは番号を出さない。
サーバーとブラウザで別の乱数を引くと、表示が食い違ううえにログとも合わない
*/
export function pickErrorRef(
  serverRef: string | null | undefined,
): string | null {
  if (!documentHydrated) return serverRef ?? null;
  return newErrorRef();
}
